module.exports = __webpack_public_path__ + "img/carousel-clientes-8.4e16550d.png";